import { el, setAttr } from 'redom';

import { extractLogoCharactersFromText } from './utilities';

class TextLogo {

  constructor(configuration) {

    const theme = configuration.theme;
    const logoCharacters = extractLogoCharactersFromText(configuration.text, configuration.maximumLetters);

    this.el = el('div', {
      class: 'text-logo-main',
      style: {
        'background-color': theme.colors.primary
      }
    }, [
      el('p', {
        class: 'text-logo-content',
        style: {
          'font-family': theme.fontFamily
        }
      }, [logoCharacters])
    ]);

  }

  updateContainer(theme) {

    setAttr(this.el, {
      style: {
        'background-color': theme.colors.primary,
      }
    });

  }

  updateLogo(theme, logoCharacters) {

    const element = this.el.querySelector('p');

    setAttr(element, {
      style: {
        'font-family': theme.fontFamily
      }
    });

    element.textContent = logoCharacters;

  }

  update(configuration) {

    const theme = configuration.theme;
    const logoCharacters = extractLogoCharactersFromText(configuration.text, configuration.maximumLetters);

    this.updateContainer(theme);
    this.updateLogo(theme, logoCharacters);

  }

}

export default TextLogo;